export class TagKeyValuesCondition {
    'operator';
    'tagKeyValues';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "tagKeyValues",
            "baseName": "tagKeyValues",
            "type": "Array<TagKeyValue>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TagKeyValuesCondition.attributeTypeMap;
    }
    constructor() {
    }
}
